<template>
  <div v-if="canAdd">
    <v-speed-dial
      v-model="fab"
      class="add-contents"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :transition="transition"
      direction="left"
      fixed
    >
      <template v-slot:activator>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-model="fab"
              color="#f9b418"
              class="elevation-1"
              v-bind="attrs"
              v-on="on"
              fab
            >
              <v-icon v-if="fab"> fal fa-times </v-icon>
              <v-icon v-else> fal fa-plus </v-icon>
            </v-btn>
          </template>
          <span> Add Content(s) </span>
        </v-tooltip>
      </template>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn
            color="#f9b418"
            class="elevation-0"
            v-on="on"
            @click.stop="toggleAddCurriculumDialog"
          >
            <v-icon small class="mr-2">fal fa-plus</v-icon>

            Add Curriculum
          </v-btn>
        </template>
        <span
          ><strong>Curriculum (Certification)</strong> <br />
          refers to a set of courses.</span
        >
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn
            color="#f9b418"
            class="elevation-0"
            v-on="on"
            @click.stop="toggleAddCategoryDialog"
          >
            <v-icon small class="mr-2">fal fa-plus</v-icon>

            Add Course
          </v-btn>
        </template>
        <span
          ><strong>Course</strong> <br />
          refers to a set of modules.</span
        >
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn
            color="#f9b418"
            class="elevation-0"
            v-on="on"
            @click.stop="toggleAddModuleDialog"
          >
            <v-icon small class="mr-2">fal fa-plus</v-icon>

            Add Module
          </v-btn>
        </template>
        <span
          ><strong>Module</strong> <br />
          refers to a set of series.</span
        >
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn
            color="#f9b418"
            class="elevation-0"
            v-on="on"
            @click.stop="toggleAddSeriesDialog"
          >
            <v-icon small class="mr-2">fal fa-plus</v-icon>

            Add Series
          </v-btn>
        </template>
        <span
          ><strong>Series</strong> <br />
          refers to a set of units.</span
        >
      </v-tooltip>
    </v-speed-dial>
    <add-curriculum-dialog
      :add-curriculum-dialog="addCurriculumDialog"
      :toggle-add-curriculum-dialog="toggleAddCurriculumDialog"
      :closeModal="toggleClose"
      v-on:curriculum="fetchChanges"
    ></add-curriculum-dialog>
    <add-category-dialog
      :add-category-dialog="addCategoryDialog"
      :toggle-add-category-dialog="toggleAddCategoryDialog"
      :closeModal="toggleClose"
      v-on:course="fetchChanges"
    ></add-category-dialog>
    <add-module-dialog
      :add-module-dialog="addModuleDialog"
      :toggle-add-module-dialog="toggleAddModuleDialog"
      :closeModal="toggleClose"
      v-on:added-module="fetchChanges"
    ></add-module-dialog>
    <add-series-dialog
      :add-series-dialog="addSeriesDialog"
      :toggle-add-series-dialog="toggleAddSeriesDialog"
      :closeModal="toggleClose"
      v-on:series="fetchChanges"
    ></add-series-dialog>
  </div>
</template>

<script>
import { some as _some } from 'lodash-es';
import AddCurriculumDialog from '@/components/course-certification/includes/AddCurriculumDialog';
import AddCategoryDialog from '@/components/course-certification/includes/AddCategoryDialog';
import AddModuleDialog from '@/components/course-certification/includes/AddModuleDialog';
import AddSeriesDialog from '@/components/course-certification/includes/AddSeriesDialog';
import EventBus from '@/plugins/eventBus';

export default {
  name: 'AddContent',
  components: {
    AddCategoryDialog,
    AddModuleDialog,
    AddCurriculumDialog,
    AddSeriesDialog,
  },
  data: () => ({
    addCurriculumDialog: false,
    addCategoryDialog: false,
    addModuleDialog: false,
    addSeriesDialog: false,
    top: false,
    right: true,
    bottom: true,
    left: false,
    fab: false,
    transition: 'slide-y-reverse-transition',
  }),
  computed: {
    user() {
      return this.$auth.user();
    },
    roles() {
      return this.$auth.user().roles;
    },
    isCurrentUserSuperAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
    isCurrentUserManager() {
      return (
        _some(this.roles, { name: 'account-manager' }) ||
        _some(this.roles, { name: 'specific-dealer-manager' })
      );
    },
    canAdd() {
      return this.isCurrentUserSuperAdmin || this.isCurrentUserManager;
    },
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
  methods: {
    fetchChanges() {
      EventBus.$emit('refreshCourseCertification');
    },
    toggleAddCurriculumDialog() {
      this.addCurriculumDialog = !this.addCurriculumDialog;

      this.addCategoryDialog = false;
      this.addModuleDialog = false;
      this.addSeriesDialog = false;
    },
    toggleAddCategoryDialog() {
      this.addCategoryDialog = !this.addCategoryDialog;
      this.addCurriculumDialog = false;
      this.addModuleDialog = false;
      this.addSeriesDialog = false;
    },
    toggleAddModuleDialog() {
      this.addModuleDialog = !this.addModuleDialog;
      this.addCurriculumDialog = false;
      this.addCategoryDialog = false;
      this.addSeriesDialog = false;
    },
    toggleAddSeriesDialog() {
      this.addSeriesDialog = !this.addSeriesDialog;
      this.addCurriculumDialog = false;
      this.addCategoryDialog = false;
      this.addModuleDialog = false;
    },
    toggleClose() {
      this.addCurriculumDialog = false;
      this.addCategoryDialog = false;
      this.addModuleDialog = false;
      this.addSeriesDialog = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.add-contents {
  bottom: 0px;
  margin: 10px 0px 150px 0px;
}
.add-contents v-icon {
  color: #59400D;
}
</style>
